import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Organizer } from '../models/organizer';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class OrganizerService {

  constructor(private http: HttpClient) { }

  get(id: string): Promise<Organizer> {
    return this.getWithRest('organizer_id/' + id);
  }

  private getWithRest(rest_url: string) : Promise<Organizer> {
    return new Promise((resolve, reject) => {
      return this.http.get(AppSettings.API_ENDPOINT + 'organizers/' + rest_url).subscribe((response:any) => {

        if(response.type == 'organizer' && response.data){
          resolve(response.data);
        } else {
          reject(response);
        }

      },
        error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
    });
  }


}
